/**
 * Guarda o cálculo que o anônimo acabou de fazer, pra salvar automaticamente
 * assim que ele criar a conta (fecha o loop "salve este cálculo"). Fica em
 * sessionStorage — some se ele não converter. O save é best-effort: se o
 * shape não bater com o schema do servidor, falha em silêncio (nunca erro
 * na cara de quem acabou de se cadastrar).
 */
export interface PendingCalc {
  tipo: 'MARGEM_LUCRO' | 'PRECO_HORA' | 'PRECIFICACAO' | 'FATURAMENTO' | 'FLUXO_CAIXA' | 'CALENDARIO_DAS'
  inputs: Record<string, unknown>
  resultado: Record<string, unknown>
  titulo?: string
}

const KEY = 'calculamei:pending_calc'

export function stashPendingCalc(c: PendingCalc) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(c))
  } catch {
    // sessionStorage indisponível — ignora
  }
}

export function popPendingCalc(): PendingCalc | null {
  try {
    const v = sessionStorage.getItem(KEY)
    if (!v) return null
    sessionStorage.removeItem(KEY)
    return JSON.parse(v) as PendingCalc
  } catch {
    return null
  }
}
